const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1", "::1"]);

function normalizeBasePath(basePath = "/"): string {
  const trimmed = basePath.trim();
  if (!trimmed) return "/";
  const path = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  return path.endsWith("/") ? path : `${path}/`;
}

function getRuntimeAppUrl(): string {
  if (typeof window === "undefined") return "/";
  return new URL(
    normalizeBasePath(process.env.BASE_URL || "/"),
    `${window.location.origin}/`
  ).toString();
}

function resolveConfiguredUrl(configuredUrl: string | undefined): string {
  const runtimeUrl = getRuntimeAppUrl();
  if (!configuredUrl) return runtimeUrl;

  try {
    const candidate = new URL(configuredUrl, runtimeUrl);
    if (typeof window !== "undefined") {
      const runtimeIsLocal = LOCAL_HOSTNAMES.has(window.location.hostname);
      const configuredIsLocal = LOCAL_HOSTNAMES.has(candidate.hostname);

      if (runtimeIsLocal !== configuredIsLocal) {
        return runtimeUrl;
      }
    }
    return candidate.toString();
  } catch {
    return runtimeUrl;
  }
}

export function getAuthCallbackUrl(): string {
  return resolveConfiguredUrl(process.env.VUE_APP_Auth_Callback_URL);
}

export function getLogoutReturnUrl(): string {
  return resolveConfiguredUrl(process.env.VUE_APP_logout_URL);
}
